import { type ReactNode } from 'react'
import { Card } from './Card'
import styles from './EmptyState.module.css'

interface EmptyStateProps {
  children: ReactNode
}

export function EmptyState({ children }: EmptyStateProps) {
  return (
    <Card>
      <p className={styles['text']}>{children}</p>
    </Card>
  )
}
